export const SIMPLE_MODAL_OPEN = "SIMPLE_MODAL_OPEN";
export const SIMPLE_MODAL_CLOSE = "SIMPLE_MODAL_CLOSE";
